<template>

	<div 
	class="object" 
	ref="object" 
	:style="{ 'background-image': 'url(' + require('../../assets/images/website/' + image) + ')' }"
	></div>
	
</template>

<script>

	import { TweenMax, TimelineMax } from 'gsap'

	export default {

		props: ['object', 'width', 'frames', 'height', 'left', 'top', 'image'],

		data() {

			return {

				timeline: '',
				tween: '',
				objectSequence: '',
				widthRatio: 1,
				heightRatio: 1,

			}

		},

		mounted: function () {

			window.addEventListener('resize', () => this.resizeVideo());
			this.resizeVideo()

			this.timeline = new TimelineMax({repeat:-1})

			var object = this.$refs.object;

			var self = this;

			this.tween = TweenMax.to( object, (this.frames * 0.15), { backgroundPosition:"0px "+ (-(self.height * this.frames))+"px", ease:SteppedEase.config(this.frames), repeat:-1, paused:false, repeatDelay: -0.15 });
 			
 			/*
 			for (var i = 0; i < this.frames; i++) {

 				this.tween = this.timeline.set(object, { delay:.15, onStartParams: [i], onStart:function(i)  { 

 					object.style.backgroundPosition = "0px "+ (-(self.height*i))+"px"}} )

 			}
 			*/

 		},

 		methods: {

 			resizeVideo() {

 				var width = document.body.clientWidth;
 				var height = document.body.clientHeight;

 				this.widthRatio = width / 1920;
 				this.heightRatio = (this.widthRatio * 6520) / 6520;

 				this.$refs.object.style.height = this.height + "px";
 				this.$refs.object.style.width = this.width + "px";

 				this.$refs.object.style.left = (this.left * this.widthRatio) + ( ( ( this.width * this.widthRatio ) - this.width ) / 2 ) + "px"
 				this.$refs.object.style.top = (this.top * this.heightRatio) + ( ( ( this.height * this.heightRatio ) - this.height ) / 2 ) + "px"

 				this.$refs.object.style.transform = "scale("+ this.widthRatio +")";

 			},

 		},

 	}

 </script>

<style scoped>
 	
 .object {

 	background-repeat: no-repeat;
 	position: absolute;
 	background-size: cover;
 	z-index: 9;

 }

 </style>


// WEBPACK FOOTER //
// PngSequence.vue?0e7382b6